import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { Client, ClientPk } from '../../shared/models/sale/client';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { ClientFilterSet } from '../../shared/models/sale/client-filter-set.model';

export const clientApi = createApi({
  reducerPath: 'clientApi',
  baseQuery,
  endpoints: (builder) => ({
    clientInfo: builder.query<Client, ClientPk>({
      query: ({ companyId, idNumber, searchType }) => ({
        url: `/api/companies/${companyId}/clients/${idNumber}`,
        method: 'GET',
        params: searchType === undefined ? undefined : { searchType },
      }),
    }),
    clientList: builder.query<
      IPagedResult<Client>,
      { companyCode: string; filterset: ClientFilterSet }
    >({
      query: ({ companyCode, filterset }) => ({
        url: `/api/companies/${companyCode}/clients?${serialize(filterset)}`,
        method: 'GET',
      }),
    }),
    saveClient: builder.mutation<Client, Client>({
      query: (client) => ({
        url: `/api/clients`,
        method: 'POST',
        body: client,
      }),
    }),
    updateClient: builder.mutation<Client, { id: string; client: Client }>({
      query: ({ id, client }) => ({
        url: `/api/clients/${id}`,
        method: 'PUT',
        body: client,
      }),
    }),
  }),
});

export const {
  useLazyClientInfoQuery,
  useLazyClientListQuery,
  useClientListQuery,
  useSaveClientMutation,
  useUpdateClientMutation,
} = clientApi;
